import { useMutation } from '@tanstack/react-query';

import { type MutationFunction, useRequest } from '@frontend/api';

import type { BomPart, NodeData } from './types';

export type CommitBomRequestBody = {
  quoteItemId: number;
  // data
  partMap: Record<BomPart['uuid'], BomPart>;
  nodeMap: Record<string, NodeData>;
  shouldRegenerateOperations: boolean;
};

export type CommitBomResponseBody = {
  componentIdsToRecalculate: number[];
};

export const useCommitBom: MutationFunction<
  CommitBomResponseBody,
  CommitBomRequestBody
> = ({ requestOptions, queryOptions, query } = {}) => {
  const request = useRequest(requestOptions);

  return useMutation({
    mutationFn: ({ quoteItemId, ...body }) => {
      return request(`/quotes/items/${quoteItemId}/bom_builder/`, {
        query,
        init: {
          method: 'POST',
          body,
        },
      });
    },
    ...queryOptions,
  });
};
